// extracted by mini-css-extract-plugin
export default {"root":"vB9CVnrV","info":"_5SB6bTZD","link":"CYNEEhbP","forecaLogo":"B0Dl3zcZ"};